module.exports = __webpack_public_path__ + "static/media/gu.b6bb445b.svg";